module.exports = __webpack_public_path__ + "assets/img/favicons/apple-icon-120x120.png";